(function($){

var postsPerPage = 12;
var pageNumber = 1;
var maxNumPages = $("#lnm-home-btn-load-more").data('max-num-pages');

$("#lnm-home-btn-load-more").on("click",function(e){
	e.preventDefault(); 
    home_load_more_posts();
});

// var_lnm_ajax

function home_load_more_posts(){

	pageNumber++;
        
    $.ajax({
        type: "POST",
        dataType: "html",
        url: var_lnm_ajax.url,
        data: {
        	action : var_lnm_ajax.action,
			nonce: var_lnm_ajax.nonce,
            callback: 'lnm_load_more_posts',
			pageNumber: pageNumber,
			postsPerPage : postsPerPage
        },
        beforeSend: function(){
			$("#lnm-home-btn-load-more").attr("disabled",true); // Disable the button, temp.
		},
        success: function(data){

        	if(data.length){
                $("#lnm-home-grid").append(data);
                $("#lnm-home-btn-load-more").attr("disabled",false);
            } else{
                $("#lnm-home-btn-load-more").attr("disabled",true);
            }

            if(pageNumber >= maxNumPages){
				$("#lnm-home-btn-load-more").attr("disabled",true);
			}

        },
        error : function(jqXHR, textStatus, errorThrown) {
        	console.log('error');
        }

    });

    return false;
}




})(jQuery)